module.exports = __webpack_public_path__ + "static/media/sfx_animal_lion.04cd0af1.mp3";